/***********************************************************/
/***********************************************************/
/* Vault Withdraw Checkout Module */
/***********************************************************/
/***********************************************************/
var vaultWithdrawCheckoutModule = (function() {

  var url = '/checkout/vaultwithdrawal/',
    token = '',
    updateFlag,
    costs = {
      withdrawalCost: '0',
      storageFee: '0',
      paymentCost: '0',
      shippingCost: '0',
      insuranceCost: '0',
    },
    completionCheckCount = 0,
    completionCheckDelay = 0,
    oldPaymentMethodIds = [],
    oldShippingMethodIds = [],
    fpLocation,
    response;

  let personalCollectionSG = 3;

  /*
    DESC: Initialize vault withdraw checkout. USED IN: /vault/withdraw
    POST /checkout/vaultwithdrawal/init
  */

  function init(cb) {
    var req = new Request(servicesUrl + url + 'init', {
      currency: getCurrency(),
      locationId: getLocation()
    });

    req.afterErrorDialogFunction(function(res) {
      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);

        sendComputeTaxes();

        if (getLocation() == 1) {
          localStorage.removeItem('reservation-time-slot');
        }
      }
    });

    req.call();
  }

  function showPaymentDescription() {
    var $selectedOption = $('select[name=payment] option:selected');
    $('.select-payment-description').addClass('hide');
    $('.select-payment-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');
  }

  function findTimeSlots(selectedDate, reservationDates) {
    for (var i = 0; i < reservationDates.length; i++) {
      if (reservationDates[i].title == selectedDate) {
        return reservationDates[i].timeSlots;
      }
    }

    return null;
  }

  function getAvailableTimeSlots(selectedDate, reservationDates) {
    let availableTimeSlots = findTimeSlots(selectedDate, reservationDates);
    let timeSlotSelectEl = $('#reservation-time-slots');
    let option = document.createElement('option');
    option.value = "";
    option.innerHTML = "Select Time Slot";
    timeSlotSelectEl.append(option);
    if (availableTimeSlots) {
      for (let i = 0; i < availableTimeSlots.length; i++) {
        let option = document.createElement('option');
        option.value = availableTimeSlots[i].value;
        option.innerHTML = availableTimeSlots[i].displayString;
        timeSlotSelectEl.append(option);
      }
    }

    return availableTimeSlots;
  }

  function handleResponse(res, currencyChanged) {
    // if(res.location == null) { // No product available for withdrawal, redirect to the dashboard.
    //   var options = {
    //     title: res.title,
    //     message: res.message,
    //     okCallback: function() {
    //       window.location.href = '/myaccount/dashboard';
    //     }
    //   }
    //   var popup = new Popup(options);
    //   popup.render();
    //   return;
    // }

    fpLocation = res.fpLocation;

    if (res.message.length && res.forceShipToDifferentLocation && res.location.id == 2) {
      var options = {
        title: res.title,
        message: res.message
      };

      options.customButtons = true;
      options.wide = true;
      options.buttons = [{
        name: 'Close',
        link: false,
        action: 'close'
      }];

      var popup = new Popup(options);
      popup.render();
    }

    if (res.location == null) return;
    $('.storage-location').text(res.location.title);

    if (res.requestLocation.id != res.location.id) { // Location changed by the API.
      var options = {
        title: 'Withdraw Stored Bullion',
        message: 'You don\'t have any stored items available for withdrawal in ' + res.requestLocation.title + ". Location has been changed to " + res.location.title + ".",
        okCallback: function() {}
      }
      var popup = new Popup(options);
      popup.render();

      setLocation(res.location.id, res.location.shortName);
    }

    if (res.locations.length < 2) {
      $('.change-storage-location').addClass('hide');
    } else {
      $('.change-storage-location').removeClass('hide');
    }

    // Redraw delivery dropdown
    var currentDeliveryID = $.map($('select[name=delivery] option'), function(option) {
      return option.value;
    });

    var newDeliveryID = $.map(res.shippingMethods, function(method) {
      return method.id;
    });

    // if (!arraysEqual(currentDeliveryID, newDeliveryID)) {
    // console.log('Delivery is not the Same!');
    $('#select-delivery-container').html(tmpl($('#tmpl-vault-checkout-select-delivery').html(), {
      obj: res
    }));
    // }

    // Update shipping method
    $('.select-delivery-description').each(function() {
      var id = $(this).attr('data-id');
      for (var i = 0; i < res.shippingMethods.length; ++i) {
        if (res.shippingMethods[i].id == id) {
          if ($(this).html() != res.shippingMethods[i].description) {
            if (getLocation() == 1) {
              if (res.shippingMethods[i].id != personalCollectionSG) {
                $(this).html(res.shippingMethods[i].description);
              }
            }
          }
        }
      }
    });


    if (getLocation() == 1 && $('select[name=delivery]').val() == personalCollectionSG) {
      let mapLink = $('.map-link');
      let mapAddress = $('.map-address');

      if (res.fpLocation) {
        mapLink.attr('href', 'https://goo.gl/maps/9GTa8YUAQFVrLgHh8');
        mapAddress.html('BullionStar @ Le Freeport <br> 32 Changi N Cres, Singapore 499643');
      } else {
        mapLink.attr('href', 'https://maps.google.com/?cid=9534477214764839712');
        mapAddress.html('45 New Bridge Road <br> Singapore 059398');
      }
    }

    $('select[name=delivery]').val(res.shippingMethodId);

    if (getLocation() == 1) {
      if (res.reservationDates) {
        // update time slots
        $('#reservation-time-slots').empty();
        var availableTimeSlots = getAvailableTimeSlots($('#reservation-dates').val(), res.reservationDates);

        $('#reservation-dates').change(function() {
          $('#reservation-time-slots').empty();
          getAvailableTimeSlots($('#reservation-dates').val(), res.reservationDates);
        });

        $('#reservation-time-slots').change(function() {
          localStorage.setItem('reservation-time-slot', $('#reservation-time-slots').val());
        });

        if (availableTimeSlots) {
          let timeSlotFound = availableTimeSlots.some(e => e.value == localStorage.getItem('reservation-time-slot'));
          if (!timeSlotFound) {
            $('#reservation-time-slots').val("").change();
          }
        }
      }
    }

    // Redraw payment dropdown

    var currentPaymentID = $.map($('select[name=payment] option'), function(option) {
      return option.value;
    });

    var newPaymentID = $.map(res.paymentMethods, function(method) {
      return method.id;
    });

    if (!arraysEqual(currentPaymentID, newPaymentID)) {
      console.log('Payment is not the Same!');
      $('#select-payment-container').html(tmpl($('#tmpl-vault-checkout-select-payment').html(), {
        obj: res
      }));
    }

    $('select[name=payment]').val(res.paymentMethodId);
    oldPaymentMethodIds.push(res.paymentMethodId);
    oldShippingMethodIds.push(res.shippingMethodId);

    showPaymentDescription();

    $('#delivery-cost').text(res.costs.shippingCost);

    if (res.paymentMethods.length === 1) {
      $('select[name=payment]').addClass('hide');
    } else {
      $('select[name=payment]').removeClass('hide');
    }

    if (res.shippingMethods.length === 1) {
      $('select[name=delivery]').addClass('hide');
    } else {
      $('select[name=delivery]').removeClass('hide');
    }

    let deliveryMethod = $('select[name=delivery]').val();
    if (deliveryMethod == personalCollectionSG && getLocation() == 1) {
      console.log('called payment option')
      $('select[name=payment] option[value="5"]').remove();
      $('select[name=payment] option[value="6"]').remove();
      $('select[name=payment] option[value="10"]').remove();
      $('select[name=payment] option[value="25"]').remove();
      $('select[name=payment] option[value="18"]').remove();
      $('select[name=payment] option[value="19"]').remove();
      $('select[name=payment] option[value="46"]').remove();
      $('select[name=payment] option[value="31"]').remove();
      $('select[name=payment] option[value="48"]').remove();
      $('select[name=payment] option[value="29"]').remove();
      $('select[name=payment] option[value="32"]').remove();
    }

    // Table Fees Start
    $('.location-name').html(res.location.title);

    if (res.costs.withdrawalCost) {
      $('.withrawal-fee-row').removeClass('hide');
      $('.withrawal-fee-row').find('.amount').text(res.costs.withdrawalCost);
    } else {
      $('.withrawal-fee-row').addClass('hide');
      $('.withrawal-fee-row').find('.amount').text('');
    }

    if (res.costs.storageFee) {
      $('.storage-fee-row').removeClass('hide');
      $('.storage-fee-row').find('.amount').text(res.costs.storageFee);
    } else {
      $('.storage-fee-row').addClass('hide');
      $('.storage-fee-row').find('.amount').text('');
    }

    // Table Fees End

    if (res.costs.shippingCost) {
      $('.delivery-row.value').text(res.costs.shippingCost);
    } else {
      if (res.shipping && getLocation() == 1 && getCountryCode() == 'SG') { // Apply only for Singapore
        $('.delivery-row.value').text('FREE');
      } else {
        $('.delivery-row.value').text('');
      }
    }

    $('#payment-cost').text(res.costs.paymentCost);

    if (res.costs.paymentCost) {
      $('.payment-row.value').text(res.costs.paymentCost);
    } else {
      $('.payment-row.value').text('');
    }

    if (res.costs.insuranceCost) {
      $('.insurance-row').removeClass('hide');
      $('.insurance-row').find('.value').text(res.costs.insuranceCost);
    } else {
      $('.insurance-row').addClass('hide');
      $('.insurance-row').find('.value').text('');
      $('.insurance-vat-row').addClass('hide');
    }

    $('#total').text(res.costs.total);

    var bullionIds = [];
    $.each(res.cart.items, function(i, item) {
      bullionIds.push(item.productId);
      if (item.quantityChanged) {
        $('.quantity[data-id=' + item.productId + ']').val(item.quantity);
        $('.quantity[data-id=' + item.productId + ']').attr('qty', item.quantity);
      }
      $('.vault-quantity[data-id=' + item.productId + ']').text(item.vaultQuantity);
    });

    // Remove non existing bullion
    $.each($('.vault-quantity'), function(i, el) {
      if ($.inArray($(this).data('id'), bullionIds) == -1) {
        $('.vault-quantity[data-id=' + $(this).data('id') + ']').closest('tr').remove();
      }
    });

    // Add missing.
    $.each(res.cart.items, function(i, item) {
      if ($('.vault-quantity[data-id=' + item.productId + ']').length == 0) {
        if (i == 0) {
          $('.checkout-table > tbody').prepend(tmpl($('#tmpl-vault-withdraw-cart-items-table').html(), {
            obj: item
          }));
        } else {
          var prev = $('.vault-quantity[data-id=' + res.cart.items[i - 1].productId + ']').closest('tr');
          prev.after(tmpl($('#tmpl-vault-withdraw-cart-items-table').html(), {
            obj: item
          }));
        }
      }
    });

    costs.withdrawalCost = res.costs.withdrawalCostPlain;
    costs.storageFeePre2023 = res.costs.storageFeePre2023Plain;
    costs.storageFee2023 = res.costs.storageFee2023Plain;
    costs.storageFee2024Onwards = res.costs.storageFee2024OnwardsPlain;
    costs.paymentCost = res.costs.paymentCostPlain;
    costs.shippingCost = res.costs.shippingCostPlain;
    costs.insuranceCost = res.costs.insuranceCostPlain;

    token = res.priceLockToken;

    if (res.shipping) {
      $('.shipping').removeClass('hide');

      if (res.shippingCountries.length) {
        var options = '';
        var selected = '';
        var cc = []
        $.each(res.shippingCountries, function(i, country) {
          options += '<option value="' + country.code + '">' + country.name + '</option>';
          cc.push(country.code);
        });

        // Update country options and selection.
        var previousShippingCountry = $('#shipping-country').val();
        $('#shipping-country').html(options);

        // US, allow only shipping to US
        if (res.location.id === 2 && !$('#ship-to-another-address').is(':checked') && res.shippingCountry !== 'US') {
          $('#ship-to-another-address').attr("disabled", true);
          $('#ship-to-another-address')[0].checked = true;
          $('.shipping-forms').removeClass('hide');
          $('.shipping-forms .country-select').trigger('change');
        } else if (cc.includes(res.shippingCountry)) {
          if (res.location.id === 2) {
            if (getCountryCodeField().val() == "US") {
              $('#ship-to-another-address').removeAttr("disabled");
            } else {
              $('#ship-to-another-address').attr("disabled", true);
            }
          } else {
            $('#ship-to-another-address').removeAttr("disabled");
          }
          localStorage.setItem('shipping-country', res.shippingCountry);
          $('#shipping-country').val(res.shippingCountry);
          if (previousShippingCountry != res.shippingCountry) {
            $('#shipping-country').trigger('change');
          }

          // Make sure to only have 1 #shipping-country selection
          var $parent = $('#shipping-country').parent();

          // Remove copy of selection on update that causes bug
          $parent.find('.country-selection-list').remove();

          // Update Selected Flag
          $parent.find('.flag').removeClass().addClass('flag flag-' + res.shippingCountry.toLowerCase());

          countrySelect('#shipping-country');
        }
      }

      changeShippingCountryDisplayOnDeliveryDescription();
    } else {
      $('.shipping').addClass('hide');
      $('#ship-to-another-address').removeAttr("disabled");
      $('#ship-to-another-address')[0].checked = false;
      $('.shipping-forms').addClass('hide');
    }

    loadCreditCard();

    termsTextSwitching(res);

    if (res.displayCreditCardFields) {
      var $ccNameField = $('input[data-input-type="creditcard-holder-name"]');
      var $ccNumberField = $('input[data-input-type="creditcard-number"]');
      var $ccCCVField = $('input[data-input-type="creditcard-exp-cvv"]');
      $('.credit-card-form').removeClass('hide');
      $('.with-card .cards-logo').removeClass('hide');
      if (!$ccNameField.val().length) $ccNameField.val(res.creditCardName).prev().addClass('active')
      if (cachedCCNumber) $ccNumberField.val(cachedCCNumber).trigger('input').prev().addClass('active');
      if (cachedCVV) $ccCCVField.val(cachedCVV).prev().addClass('active');
    } else {
      $('.credit-card-form').addClass('hide');
      $('.with-card .cards-logo').addClass('hide');
    }
  }

  function updateCheckoutTaxItems(res) {
    if (res.taxes.withdrawalCostVat) {
      $('.withrawal-fee-vat-row').removeClass('hide');
      $('.withrawal-fee-vat-row .label').text(res.taxes.withdrawalTaxLabel);
      $('.withrawal-fee-vat-row').find('.amount').text(res.taxes.withdrawalCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.withdrawalTaxLabel != 'Taxes') { // Combination
        $('.withrawal-fee-row.subtitle').addClass('-italic');
        $('.withrawal-fee-row.value').addClass('-italic');
      } else {
        $('.withrawal-fee-row.subtitle').removeClass('-italic');
        $('.withrawal-fee-row.value').removeClass('-italic');
      }
    } else {
      $('.withrawal-fee-vat-row').addClass('hide');
      $('.withrawal-fee-vat-row .label').text('');
      $('.withrawal-fee-vat-row').find('.amount').text('');
    }

    if (res.taxes.storageFeeVat) {
      $('.storage-fee-vat-row').removeClass('hide');
      $('.storage-fee-vat-row .label').text(res.taxes.storageTaxLabel);
      $('.storage-fee-vat-row').find('.amount').text(res.taxes.storageFeeVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.storageTaxLabel != 'Taxes') { // Combination
        $('.storage-fee-vat-row.subtitle').addClass('-italic');
        $('.storage-fee-vat-row.value').addClass('-italic');
      } else {
        $('.storage-fee-vat-row.subtitle').removeClass('-italic');
        $('.storage-fee-vat-row.value').removeClass('-italic');
      }
    } else {
      $('.storage-fee-vat-row').addClass('hide');
      $('.storage-fee-vat-row .label').text('');
      $('.storage-fee-vat-row').find('.amount').text('');
    }

    if (res.taxes.shippingCostVat) {
      $('.delivery-vat-row-label').text(res.taxes.shippingTaxLabel);
      $('.delivery-vat-row.value').text(res.taxes.shippingCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.shippingTaxLabel != 'Taxes') { // Combination
        $('.delivery-vat-row.subtitle').addClass('-italic');
        $('.delivery-vat-row.value').addClass('-italic');
      } else {
        $('.delivery-vat-row.subtitle').removeClass('-italic');
        $('.delivery-vat-row.value').removeClass('-italic');
      }
    } else {
      $('.delivery-vat-row-label').text('');
      $('.delivery-vat-row.value').text('');
    }


    if (res.taxes.insuranceCostVat) {
      $('.insurance-vat-row.subtitle').text(res.taxes.insuranceTaxLabel);
      $('.insurance-vat-row.value').text(res.taxes.insuranceCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.insuranceTaxLabel != 'Taxes') { // Combination
        $('.insurance-vat-row.subtitle').addClass('-italic');
        $('.insurance-vat-row.value').addClass('-italic');
      } else {
        $('.insurance-vat-row.subtitle').removeClass('-italic');
        $('.insurance-vat-row.value').removeClass('-italic');
      }
    } else {
      $('.insurance-vat-row.subtitle').text('');
      $('.insurance-vat-row.value').text('');
    }

    if ($('.insurance-row').is(':visible')) {
      $('.insurance-vat-row').removeClass('hide');
    }

    if (res.taxes.paymentCostVat) {
      $('.payment-vat-row-label').text(res.taxes.paymentTaxLabel);
      $('.payment-vat-row.value').text(res.taxes.paymentCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.paymentTaxLabel != 'Taxes') { // Combination
        $('.payment-vat-row.subtitle').addClass('-italic');
        $('.payment-vat-row.value').addClass('-italic');
      } else {
        $('.payment-vat-row.subtitle').removeClass('-italic');
        $('.payment-vat-row.value').removeClass('-italic');
      }
    } else {
      $('.payment-vat-row-label').text('');
      $('.payment-vat-row.value').text('');
    }

    $('#total').text(res.taxes.totalAmountToPay);

    if (res.taxes.totalVat && res.taxes.totalTaxLabel.length > 0) {
      $('.total-vat-row').removeClass('hide');
      $('.total-vat-row .subtitle').text(res.taxes.totalTaxLabel);
      $('.total-vat-row').find('.value').text(res.taxes.totalVat);
    } else {
      $('.total-vat-row').addClass('hide');
      $('.total-vat-row .subtitle').text('');
      $('.total-vat-row').find('.value').text('');
    }

    if ($('.total-vat-row').is(':visible')) {
      $('.withdraw-total-row td:first-child').removeClass('bb-lr-20');
      $('.withdraw-total-row td:last-child').removeClass('bb-rr-20');
      $('.withdraw-total-row td:nth-child(2)').removeClass('title');
      $('.withdraw-total-row td:nth-child(3)').removeClass('last-amount');
      $('.withdraw-total-row td:nth-child(2)').removeClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(3)').removeClass('padding-bot-10');
      $('.total-vat-row td:first-child').addClass('bb-lr-20');
      $('.total-vat-row td:last-child').addClass('bb-rr-20');
    } else {
      $('.withdraw-total-row td:first-child').addClass('bb-lr-20');
      $('.withdraw-total-row td:last-child').addClass('bb-rr-20');
      $('.withdraw-total-row td:nth-child(2)').addClass('title');
      $('.withdraw-total-row td:nth-child(3)').addClass('last-amount');
      $('.withdraw-total-row td:nth-child(2)').addClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(3)').addClass('padding-bot-10');
      $('.total-vat-row td:first-child').removeClass('bb-lr-20');
      $('.total-vat-row td:last-child').removeClass('bb-rr-20');
    }
  }

  function termsTextSwitching(res) {
    $('.terms-text').addClass('hide');

    if (res.requireProofOfDispatch) {
      $('.proof-of-dispatch-terms').removeClass('hide');
    } else if (isCryptoCurrency(res.currency)) { // Check Crypto
      $('.crypto-terms').removeClass('hide');
    } else if (res.displayCreditCardFields) { // Check Credit Card
      $('.credit-card-terms').removeClass('hide');
      if (isShipping(res.shippingMethodId)) { // shipping
        if (res.shippingCountry !== 'SG') {
          $('.shipping-terms').removeClass('hide');
        }
      } else {
        $('.shipping-terms').addClass('hide');
      }
    } else if (res.bankTransfer) { // .bank-transfer-terms
      $('.bank-transfer-terms').removeClass('hide');
    } else { // Default
      $('.default-terms').removeClass('hide');
    }

    // if (res.shipping && res.shippingCountry !== 'SG') { // Check Shipping
    //   $('.shipping-terms').removeClass('hide');
    // }

    if (res.shippingExternal) {
      $('.external-shipping').removeClass('hide');
    } else {
      $('.external-shipping').addClass('hide');
    }
  }

  function sendUpdate(cb, getXHR, isLocationChanged, isCurrencyChanged) {
    var locationChange = isLocationChanged ? true : false;
    var currencyChanged = isCurrencyChanged ? true : false;
    var data = {
      currency: getCurrency(),
      countryCode: getCountryCodeForUpdate(),
      oldShippingMethodId: getOldShippingMethodId(oldShippingMethodIds),
      oldPaymentMethodId: getOldPaymentMethodId(oldPaymentMethodIds),
      paymentMethodId: $('select[name=payment]').val(),
      shippingMethodId: $('select[name=delivery]').val(),
      locationId: getLocation(),
      priceLockToken: token,
      productsString: isLocationChanged ? '' : generateProductString(),
      fpLocation: response.fpLocation
    }

    var addtlData = {}
    formValidationModule.addDataFromInputAndSelect(addtlData, $('.user-form-info'), false, false);
    data.state = addtlData.state;

    if ($('#ship-to-another-address').is(':checked')) {
      var shippingData = {};
      formValidationModule.addDataFromInputAndSelect(shippingData, $('.shipping-forms'), true, false);
      data.shippingName = shippingData.shippingName;
      data.shippingState = shippingData.shippingState;
      data.shippingCountryCode = shippingData.shippingCountryCode;
    }

    var xhr = update(data, function(res) {
      handleResponse(res, currencyChanged || locationChange);
      typeof cb === 'function' && cb();
    }, 1, getXHR);

    if (getXHR) {
      return xhr;
    }
  }

  function sendComputeTaxes() {
    var data = generateTaxFormFields();

    if (data.locationId == 2 && data.postCode.length == 0) { // US requires postcode.
      return null;
    }

    var xhr = taxes(data, function(res) {
      updateCheckoutTaxItems(res);
    }, 1, false);
  }

  function generateTaxFormFields() {
    var data = {
      priceLockToken: token,
      locationId: getLocation(),
      shippingMethodId: $('select[name=delivery]').val(),
      currency: getCurrency(),
      countryCode: getCountryCodeForUpdate(),
      productsString: generateTaxProductString(),
      withdrawalCost: costs.withdrawalCost,
      storageFeePre2023: costs.storageFeePre2023,
      storageFee2023: costs.storageFee2023,
      storageFee2024Onwards: costs.storageFee2024Onwards,
      paymentCost: costs.paymentCost,
      shippingCost: costs.shippingCost,
      insuranceCost: costs.insuranceCost,
      validate: false,
    }

    formValidationModule.addDataFromInputAndSelect(data, $('.user-form-info'), false, false);

    if ($('#ship-to-another-address').is(':checked')) {
      var shippingData = {};
      formValidationModule.addDataFromInputAndSelect(shippingData, $('.shipping-forms'), true, false);

      data.address1 = shippingData.shippingAddress1;
      data.address2 = shippingData.shippingAddress2;
      data.city = shippingData.shippingCity;
      data.postCode = shippingData.shippingPostCode;
      data.state = shippingData.shippingState;
      data.countryCode = shippingData.shippingCountryCode;
    }

    return data;
  }

  function getCountryCodeForUpdate() {
    if ($('#ship-to-another-address').is(':checked')) {
      return $('#shipping-country').val();
    }

    return getAccountCountryCode();
  }

  function getAccountCountryCode() {
    return $('#country').val();
  }

  function loadPage(res) {

    fpLocation = res.fpLocation;
    response = res;

    $('.currency-wrap .radio-one-line input').off('click');

    if (res.location) {
      $('.vault-checkout-wrap').html(tmpl($('#tmpl-vault-withdraw-checkout-payment').html(), {
        obj: res
      }));

      $.each(res.additionalCountries, function(i, country) {
        $('.country-select').prepend('<option value="' + country.countryCode + '">' + country.countryName + '</option>');
        $('.country-code-selection').prepend('<option value="' + country.countryCode + '" data-country="' + country.countryCodeLC + '" data-country-name="' + country.countryName + '" data-code="' + country.phoneCode + '">+' + country.phoneCode + ' ' + country.countryName + '</option>');
      });

      initLandCode('#country-code-selection');
      // Customer Info
      accountModule.setDetails(res.address);
      $('.customer-info .country').html('<br/>' + $('#country option:selected').text());
      $('.customer-info .phone-number').html('<br/> +' + $('#country-code-selection option:selected').data('code') + ' ' + res.address.phoneNumber);

      // Show Edit Details Form
      $('#btn-edit-details').on('click', function(e) {
        $('.customer-info').addClass('hide');
        $('.user-form-info').removeClass('hide');
      });
    }

    // if(detectIE() || isFirefox()) {
    //   $('.txt-pin-code').attr('type', 'password');
    // }

    handleResponse(res);
    // Removed since changing details now is a link to /myaccount/details
    //countrySelect('#country');

    $('#header-location').on('change', function() {
      sendUpdate(null, false, true);
    });

    $('.change-storage-location').on('click', function() {
      var popup = new PopupStorageLocation(res.locations);
      popup.render();
    });

    // if(localStorage.getItem('checkout-country') !== null) {
    //   $('#country').val(localStorage.getItem('checkout-country')).trigger('change');
    //   $('.customer-info .info .country').html('<br/>' + $('#country option:selected').text());
    // }

    // Removed since changing details now is a link to /myaccount/details
    // Country changed
    // $('#country').on('change', function() {
    //   sendUpdate();
    //   //localStorage.setItem('checkout-country', $(this).val());
    // });

    // Shipping info changed
    $('.shipping-forms input, .shipping-forms select').on('change', debounce(function() {
      sendUpdate();
    }, 300));

    // Delivery clicked
    $('.wrap-body').on('change', 'select[name=delivery]', function() {
      var $selectedOption = $('select[name=delivery] option:selected');

      $('.select-delivery-description').addClass('hide');
      $('.select-delivery-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');

      if (typeof updateFlag === 'object') {
        updateFlag.abort();
      }
      updateFlag = sendUpdate(null, true);
    });

    // Payment clicked
    $('.wrap-body').on('change', 'select[name=payment]', function() {

      var $selectedOption = $('select[name=payment] option:selected');

      $('.select-payment-description').addClass('hide');
      $('.select-payment-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');

      if ($selectedOption.attr('data-currency')) {
        changeCurrency($selectedOption.data('currency'));

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true, false, true);
      } else {
        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true);
      }

      // if(!$selectedOption.attr('data-currency')) {
      //   if(typeof updateFlag === 'object') {
      //     updateFlag.abort();
      //   }
      //   updateFlag = sendUpdate(null, true);
      // } else {
      //   console.log('Change Currency');

      //   if(getCurrency() !== $selectedOption.data('currency')) {
      //     var cryptoCur = $selectedOption.text();
      //     var options = {
      //       title: generateChangeCryptoCurrencyTitle(cryptoCur),
      //       message: generateChangeCryptoCurrencyMessage(cryptoCur),
      //       okCallback: function() {
      //         changeCurrency($selectedOption.data('currency'));

      //         if(typeof updateFlag === 'object') {
      //           updateFlag.abort();
      //         }
      //         updateFlag = sendUpdate(null, true, false, true);
      //       }
      //     };

      //     var popup = new Popup(options);
      //     popup.render();
      //   }
      // }
    });

    $('.currency-wrap .radio-one-line input').on('click', debounce(function() {
      var _this = $(this),
        value = _this.val();

      if (getCurrency() !== value) {
        $('.vault-checkout-wrap .payment').empty();
        changeCurrency(value);

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true, false, true);

        headerCurrencyChange();
      }
    }, 300));

    $('#payment-change-currency').on('click', function() {
      var popupCurrency = new PopupCurrency();
      popupCurrency.render();
    });

    // $('.wrap-body').on('click', '.change-currency', function() {
    //   var _this = $(this),
    //       value = _this.data('currency');

    //   if(getCurrency() !== value) {
    //     var options = {
    //       title: 'Currency Changed to Bitcoin',
    //       message: 'Please note that the currency has been changed to Bitcoin.',
    //       okCallback: function() {
    //         $('.vault-checkout-wrap .payment').empty();
    //         changeCurrency(value);
    //         //$('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').prop('checked', true);

    //         setTimeout(function() {
    //           sendUpdate();
    //         }, 300);
    //       }
    //     };

    //     var popup = new Popup(options);
    //     popup.render();
    //   }
    // });

    // Change value
    $('.vault-checkout-wrap').on('change', '.quantity', debounce(function() {
      console.log('change Fired');
      handleChange($(this).data('id'), false);
    }, 300));

    $('.vault-checkout-wrap').on('keyup', '.quantity', debounce(function(e) {
      console.log('keyup Fired');
      if (isKeycodeNumber(e)) {
        handleChange($(this).data('id'), false);
      }
    }, 300));

    $('#btn-place-order').on('click', function(e) {
      formValidationModule.validateForm($('.vault-checkout-wrap'), 'Withdraw Bullion', function(data) {
        data.cardExpMonth = $('#credit-card-exp-mm').val();
        data.cardExpYear = $('#credit-card-exp-yy').val();
        data.currency = getCurrency();
        data.paymentMethodId = $('select[name=payment]').val();
        data.shippingMethodId = $('select[name=delivery]').val();
        data.productsString = generateProductString();
        data.phoneCountry = $('#country-code-selection').val();
        data.countryCode = $('#country').val();
        data.priceLockToken = token;
        data.locationId = getLocation();
        data.ct = getCT();
        data.reservationDateTime = $('#reservation-time-slots').val();
        data.fpLocation = fpLocation;

        formValidationModule.addData(data, $('.user-form-info'), false);

        if ($('#ship-to-another-address').is(':checked')) {
          formValidationModule.addDataFromInputAndSelect(data, $('.shipping-forms'), true, false);
        }

        let selectedTimeSlot = true;
        if (getLocation() == 1) {
          if (data.shippingMethodId == personalCollectionSG && res.reservationDates) {
            console.log('called')
            console.log($('#reservation-time-slots').val())
            if (!$('#reservation-time-slots').val()) {
              popUpAppintment = new Popup({
                title: 'Withdraw Stored Bullion',
                message: 'Please select a time slot.'
              });
              popUpAppintment.render();
              selectedTimeSlot = false;
            }
          }
        }

        if (validateAgreeCheckboxes('Withdraw Stored Bullion') && selectedTimeSlot) {
          confirm(data);
        }
      }, null, true);
    });

    // Toggle shipping address
    $('#ship-to-another-address').on('change', function() {
      $('.shipping-forms').toggleClass('hide');
      changeShippingCountryDisplayOnDeliveryDescription();
      checkoutCountryChange($('.shipping-forms'));
      sendUpdate();
    });
  }

  /*
    DESC: Update vault withdraw checkout. USED IN: /vault/withdraw page
    GET /checkout/vaultwithdrawal/update
    productsString:1106
    currency:SGD
    countryCode:SG
    shippingMethodId:3
    paymentMethodId:13
  */
  function update(data, cb, noLoader, getXHR, cancelCb) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'update', data);

    //req.useRequestId(true);
    req.getXHR = getXHR || false;

    req.afterErrorDialogFunction(function(res) {
      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.afterSuccessDialogFunction(function(res) {
      if (res.displayCreditCardFields) {
        $('input[data-input-type="creditcard-number"]').prev().trigger('click');
      }
    })

    req.afterWarningCancelDialogFunction(function(res) {
      typeof cancelCb === 'function' && cancelCb(res);
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);

        sendComputeTaxes();

        if (getLocation() == 1) {
          $('#reservation-time-slots').val(localStorage.getItem('reservation-time-slot'));
        }
      }
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }

  }

  /*
    DESC: Get taxes vault withdraw checkout. USED IN: /vault/withdraw page
    GET /checkout/vaultwithdrawal/taxes
  */
  function taxes(data, cb, noLoader, getXHR, warningCancelCb, warningOkCb) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'taxes', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.afterWarningDialogFunction(function(res) {
      typeof warningOkCb === 'function' && warningOkCb(res);
    });

    req.afterWarningCancelDialogFunction(function(res) {
      typeof warningCancelCb === 'function' && warningCancelCb(res);
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  /*
    DESC: Confirm vault withdraw checkout. USED IN: /vault/withdraw page
    GET /checkout/vaultwithdrawal/confirm
    productsString:1106
    currency:SGD
    shippingMethodId:3
    paymentMethodId:13
    email:
    name:
    phoneCountry
    company:test
    address1:Marina Bay Financial Center
    address2:Level 39, 10 Marina Boulevard
    city:Santa rosa
    state:
    postCode:4412
    countryCode:SG
  */
  function confirm(data) {

    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    var req = new Request(servicesUrl + url + 'confirm', data);

    req.afterErrorDialogFunction(function(res) {
      if (res.accountLocked) {
        authenticationModule.logout();
        return;
      }

      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
        return;
      }

      formValidationModule.showError('.vault-checkout-wrap', res.errorParameter);
    });

    req.afterWarningDialogFunction(function(res) {
      req.call(true);
    })

    req.success(function(res) {
      if (res.transactionId && res.transactionId != '') {
        waitForCompletion(req, res.transactionId);
      } else {
        handleResponse(res);
        req.hideLoader();

        sendComputeTaxes();
        if (getLocation() == 1) {
          $('#reservation-time-slots').val(localStorage.getItem('reservation-time-slot'));
        }
      }
    });

    req.dontHideLoaderOnSuccess(true);
    req.call();
  }

  function waitForCompletion(confirmReq, transactionId) {
    completionCheckCount = 0;
    completionCheckDelay = 500;

    setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
  }

  /*
    DESC: Check for completion status of a submitted order. USED IN: /buy/checkout page
    GET /api/v5/buycheckout/status
    transactionId:1234-1234-1234-1234
  */
  function checkForCompletion(confirmReq, transactionId) {
    completionCheckCount++;
    if (completionCheckCount > 200) {
      completionCheckDelay = 3000;
    } else if (completionCheckCount > 50) {
      completionCheckDelay = 1000;
    } else {
      completionCheckDelay = 500;
    }

    new Request(servicesUrl + url + 'status', {
        transactionId: transactionId
      })
      .error(function(json) {
        confirmReq.hideLoader();
        var popup = new Popup({
          title: json.title,
          message: json.message
        });
        popup.render();
      }).success(function(json) {
        if (json.url && json.url != '') {
          window.location.href = json.url;
        } else if (json.stockChanges) {
          sendUpdate();
        } else {
          setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
        }
      }).send();
  }

  var quantityTimer = null;

  function handleChange(productId, delay) {
    if (delay) {
      if (quantityTimer != null) {
        clearTimeout(quantityTimer);
        quantityTimer = null;
      }
      quantityTimer = setTimeout(vaultWithdrawCheckoutHandleChange, 200, productId);
    } else {
      var _this = $('.quantity[data-id=' + productId + ']');

      if (!_this.length) return;

      var quantityString = _this.val();
      quantityString = quantityString.trim();
      if (quantityString.length == 0) {
        quantityString = '0';
      }

      var quantity = parseInt(quantityString, 10);
      if (!isNaN(quantity)) {
        _this.attr('qty', quantity);

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }

        updateFlag = sendUpdate(null, true);
      }
    }
  }

  function generateProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = parseInt($(this).val());
      if (isNaN(quantity)) {
        quantity = $(this).attr('qty');
      }

      if (str.length > 0) {
        str += ',';
      }
      str += productId + ',' + quantity;
    });

    return str;
  }

  function generateTaxProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = parseInt($(this).find('input').val());
      if (isNaN(quantity)) {
        quantity = $(this).attr('qty');
      }

      if (quantity > 0) {
        if (str.length > 0) {
          str += ',';
        }

        str += productId + '#' + quantity + '#0';
      }
    });

    return str;
  }

  function getCountryCode() {
    return getCountryCodeField().val();
  }

  function getCountryCodeField() {
    if ($('#ship-to-another-address').is(':checked')) {
      return $('#shipping-country');
    }

    if ($('#country').length > 0) {
      return $('#country');
    } else {
      return null;
    }
  }

  // Change Shipping display text on delivery description
  function changeShippingCountryDisplayOnDeliveryDescription() {
    var countryName = getCountryCodeField().find('option:selected').text();
    $('.shippingDestinationCountryAnchor').html(countryName);
  }

  return {
    init: init,
    loadPage: loadPage,
    update: update,
    handleChange: handleChange,
    confirm: confirm,
    termsTextSwitching: termsTextSwitching,
    generateProductString: generateProductString
  }
}());

function vaultWithdrawCheckoutHandleChange(productId) {
  vaultWithdrawCheckoutModule.handleChange(productId, false);
}


/* Add for mocha testing */
// Basically it make the vaultWithdrawCheckoutModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = vaultWithdrawCheckoutModule;
}